<template>
  <div class="relative">
    <div class="d-flex justify-end align-center action-header pa-2" v-if="selected.length">
      <v-btn outlined color="success" @click="() => onAttendAll('present')" class="mr-2">tất cả có mặt</v-btn>
      <v-btn outlined color="warning" @click="() => onAttendAll('absent')">tất cả vắng mặt</v-btn>
    </div>
    <v-data-table :items="slotStudentAttendances" :headers="headers" disable-sort show-select v-model="selected">
      <template v-slot:item="{ item, expand, isExpanded, select, isSelected }">
        <TableRow
          :item="item"
          :expand="expand"
          :isExpanded="isExpanded"
          :select="select"
          :isSelected="isSelected"
          @reset="init"
        />
      </template>
    </v-data-table>
    <PopupConfirmStatus ref="popup-confirm" />
  </div>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import PopupConfirmStatus from './PopupConfirmStatus.vue'
import { headers } from './headers'
import { mapActions, mapState } from 'vuex'
import TableRow from './TableRow.vue'
export default {
  components: { CardStudentName, TableRow, PopupConfirmStatus },
  data() {
    return { students: [], headers, selected: [], status: null }
  },
  async mounted() {
    await this.init()
  },
  computed: {
    ...mapState({
      slot: (state) => state.ClassNoteDetail.slot,
      slotStudentAttendances: (state) => state.slotStudentAttendance.slotStudentAttendances,
    }),
  },
  methods: {
    ...mapActions({
      fetch: 'slotStudentAttendance/fetch',
      count: 'slotStudentAttendance/count',
      updateMany: 'slotStudentAttendance/updateMany',
    }),
    async init() {
      const date = this.$route.params.date
      this.fetch({ slot: this.slot.id, date })
    },
    async updateAll(status, subStatus) {
      try {
        this.$loading.active = true
        await this.updateMany({ listId: this.selected.map((i) => i._id), status, subStatus })
        this.$alert.success('Điểm danh thành công')
        this.init()
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.$loading.active = false
      }
    },
    onAttendAll(status) {
      this.$refs['popup-confirm'].show({
        status,
        done: (subStatus) => this.updateAll(status, subStatus),
        cancel: () => {},
      })
    },
  },
  filters: {
    getStatus() {
      return 'Chưa điểm danh'
    },
  },
}
</script>
